import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { navigate } from '@reach/router'
import { get } from 'lodash'
import * as Accessa from 'accessa'
import { useTranslation } from 'react-i18next'
import { filterByNodeLocale } from '../utils/i18n-helpers'

const toLowerCase = (s) => String(s).toLowerCase()

const includesSome = (a = [], term) =>
  a.some((item) => item.includes(toLowerCase(term)))

const isApartOf = (title) => (item) =>
  item.apartOf ? item.apartOf.title === title : false

export const hasMatch = (searchTerm) => ({
  listItemText,
}) =>
  includesSome(
    toLowerCase(listItemText).split(/\s/),
    searchTerm
  )

const getListItemTextFromHero = (item) => ({
  ...item,
  listItemText: get(item, 'hero.title'),
})

const Search = () => {
  const { t } = useTranslation('titles')
  const data = useStaticQuery(graphql`
    {
      allContentfulSubPage {
        nodes {
          relativePath
          node_locale
          hero {
            title
          }
          apartOf {
            title
          }
        }
      }

      allContentfulBlog {
        nodes {
          relativePath
          node_locale
          title
        }
      }
    }
  `)

  return (
    <Accessa.Search.SearchOverlay
      searchRequest={(v) => {
        if (!v) return Promise.resolve({})

        const filterBySearchRequestTerm = (a = []) =>
          a.filter(hasMatch(v)).map((item) => ({
            onClick: () => navigate(item.relativePath),
            ...item,
          }))

        const groupByArchive = (name) =>
          filterBySearchRequestTerm(
            data.allContentfulSubPage.nodes
              .filter(filterByNodeLocale)
              .filter(isApartOf(name))
              .map(getListItemTextFromHero)
          )

        return Promise.resolve({
          [t('applications')]: groupByArchive(
            'Applications'
          ),
          [t('industries')]: groupByArchive('Industries'),
          [t('blogs')]: filterBySearchRequestTerm(
            get(data, 'allContentfulBlog.nodes', []).map(
              (item) => ({
                ...item,
                listItemText: item.title,
              })
            )
          ),
        })
      }}
    />
  )
}

Search.propTypes = {}

Search.defaultProps = {}

export default Search
